/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { ListsWidget3, TablesWidget10 } from '../../../_metronic/partials/widgets'
import { Card5 } from './components/StatsWidget'
import { getStats } from './core/_requests'
import { useCompanies } from '../../modules/auth/core/Companies'
import { ChartsWidget2 } from './components/FilterWidget'
import { ChartsWidget } from './components/PageViewCharts'

const DashboardPage: FC = () => {

  const [statsData, setStatsData] = useState<any>({
    'PAGE_VIEW': 0,
    'CHAT_START': 0,
    'VISTOR_VIEW': 0,
    'LEAD_SHARED': 0,
  });

  const [graphData, setgraphData] = useState<any>({
    "name": "Page Views",
    "title": 'Recent Page Views',
    "description": 'Last 6 months page views',
    "data": {
      "xaxis": [
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov"
      ],
      "yaxis": [
        0,
        2,
        1,
        3,
        0,
        0
      ]
    },
    "chart": {
      "fontFamily": "inherit",
      "type": "area",
      "height": 350,
      "toolbar": {
        "show": false
      }
    }
  });


  
  const [vistorGraph, setvistorGraph] = useState<any>({
    "name": "Page Views",
    "title": 'Recent Page Views',
    "description": 'Last 6 months page views',
    "data": {
      "xaxis": [
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov"
      ],
      "yaxis": [
        0,
        2,
        1,
        3,
        0,
        0
      ]
    },
    "chart": {
      "fontFamily": "inherit",
      "type": "area",
      "height": 350,
      "toolbar": {
        "show": false
      }
    }
  });

  const [chatNewGraphData, setchatNewGraphData] = useState<any>({
    "title": "Recent New Chats",
    "description": "New Chats in last 30 days",
    "data": {
        "xaxis": [
            "21",
            "20",
            "19",
            "18",
            "17",
            "16",
            "15",
            "14",
            "13",
            "12",
            "11",
            "10",
            "09",
            "08",
            "07",
            "06",
            "05",
            "04",
            "03",
            "02",
            "01",
            "31",
            "30",
            "29",
            "28",
            "27",
            "26",
            "25",
            "24",
            "23"
        ],
        "yaxis": [
            2,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    "chart": {
        "fontFamily": "inherit",
        "type": "area",
        "height": 350,
        "toolbar": {
            "show": false
        }
    }
});
  const { defaultCompany } = useCompanies()
  const [selectedFilter, setSelectedFilter] = useState('all'); // 'all', 'last7days', 'last30days', 'lastYear'

  const handleFilterClick = (filter: string) => {
    setSelectedFilter(filter);
    getStats(defaultCompany?.company_id ?? '', filter)
      .then((data) => {
        setStatsData(data.eventCounts);
      })
      .catch((error) => {
        console.error('Error fetching statistics:', error);
      });
  };

  useEffect(() => {
    getStats(defaultCompany?.company_id ?? '', selectedFilter)
      .then((data) => {
        setgraphData(data.graph);
        setchatNewGraphData(data.graph1);
        setvistorGraph(data.graph2);
        setStatsData(data.eventCounts);
      })
      .catch((error) => {
        console.error('Error fetching statistics:', error);
      });
  }, []);

  return (<>

    {/* end::Row */}
    {/* begin::Row */}
    <div>
      <ChartsWidget2 className='card-xl-stretch' selectedFilter={selectedFilter} onFilterClick={handleFilterClick} />
    </div>

    <div className='row gy-10 gx-xl-8'>
      <div className='row g-6 g-xl-9'>
        <div className='col-sm-6 col-xl-3'>
          <Card5
            image='/media/svg/dashboard/pv.svg'
            title='Page Views'
            description={statsData['PAGE_VIEW']}
            status='down'
            statusValue={40.5}
            statusDesc='Last 7 days'
            progress={0.5}
            progressType='Impressions'
          />
        </div>
        <div className='col-sm-6 col-xl-3'>
          <Card5
            image='/media/svg/dashboard/users.svg'
            title='Visitors'
            description={statsData['VISTOR_VIEW']}
            status='up'
            statusValue={17.62}
            statusDesc=' '
            progress={5}
            progressType='New '
          />
        </div>
        <div className='col-sm-6 col-xl-3'>
          <Card5
            image='/media/svg/dashboard/message.svg'
            title='Chats Initiated'
            description={statsData['CHAT_START']}
            status='down'
            statusValue={10.45}
            statusDesc=' '
            progress={40}
            progressType='Increase'
          />
        </div>
        <div className='col-sm-6 col-xl-3'>
          <Card5
            image='/media/svg/dashboard/leads.svg'
            title='Leads Received'
            description={statsData['LEAD_SHARED']}
            status='up'
            statusValue={26.1}
            statusDesc=' '
            progress={10}
            progressType='Increase'
          />
        </div>


      </div>
      <div className='row mt-8'>
        <div className='col-sm-6 col-xl-6'>
          <ChartsWidget className='card-xxl-stretch mb-xl-3' data={graphData} />
        </div>
        <div className='col-sm-6 col-xl-6'>
        <ChartsWidget className='card-xxl-stretch mb-xl-3' data={vistorGraph} />
        </div>

      </div>

      <div className='row mt-5'>
        <div className='col-sm-12 col-xl-12'>
          <ChartsWidget className='card-xxl-stretch mb-xl-3' data={chatNewGraphData} />
        </div>
      </div>


    </div>
    {/* end::Row */}
  </>);
}

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
